var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 8.4165C11.6774 8.4165 11.4165 8.67738 11.4165 8.99984C11.4165 9.32229 11.6774 9.58317 11.9998 9.58317H13.2498V8.4165H11.9998ZM9.9165 8.99984C9.9165 7.84896 10.849 6.9165 11.9998 6.9165H13.3332C14.1154 6.9165 14.7498 7.55096 14.7498 8.33317V9.6665C14.7498 10.4487 14.1154 11.0832 13.3332 11.0832H11.9998C10.849 11.0832 9.9165 10.1507 9.9165 8.99984Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.08325C2.86221 3.08325 2.75 3.19547 2.75 3.33325C2.75 3.47104 2.86221 3.58325 3 3.58325H12C13.1509 3.58325 14.0833 4.51571 14.0833 5.66659V7.66659C14.0833 8.0808 13.7475 8.41659 13.3333 8.41659C12.9191 8.41659 12.5833 8.0808 12.5833 7.66659V5.66659C12.5833 5.34413 12.3225 5.08325 12 5.08325H3C2.03379 5.08325 1.25 4.29947 1.25 3.33325C1.25 2.36704 2.03379 1.58325 3 1.58325H11.3333C11.7475 1.58325 12.0833 1.91904 12.0833 2.33325C12.0833 2.74747 11.7475 3.08325 11.3333 3.08325H3Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.58325C2.41421 2.58325 2.75 2.91904 2.75 3.33325V12.3333C2.75 12.6557 3.01088 12.9166 3.33333 12.9166H12C12.3225 12.9166 12.5833 12.6557 12.5833 12.3333V10.3333C12.5833 9.91904 12.9191 9.58325 13.3333 9.58325C13.7475 9.58325 14.0833 9.91904 14.0833 10.3333V12.3333C14.0833 13.4841 13.1509 14.4166 12 14.4166H3.33333C2.18245 14.4166 1.25 13.4841 1.25 12.3333V3.33325C1.25 2.91904 1.58579 2.58325 2 2.58325Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.90897bb1a96ab091f41506b136007135.svg";
export { ForwardRef as ReactComponent };